import Vue from 'vue'
import Vuex from 'vuex'
import mutations from "./mutations";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username : 'admin',
    password : '123' ,

    notesListBScroll : null ,

    loading : false ,

    qrCodePolling : '123' ,
  },
  mutations: {
    ...mutations,
    setQRCode(state ,bool){
      state.qrCodePolling = bool ;
    }
  },
  actions: {
  },
  modules: {
  }
})
